var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 0.65625H1.1875C0.905707 0.65625 0.635456 0.768192 0.436199 0.967449C0.236942 1.16671 0.125 1.43696 0.125 1.71875V5.62145C0.125 11.5728 5.15992 13.5464 6.16797 13.8811C6.38319 13.9547 6.61681 13.9547 6.83203 13.8811C7.84141 13.5457 12.875 11.5721 12.875 5.62078V1.71875C12.875 1.43696 12.7631 1.16671 12.5638 0.967449C12.3645 0.768192 12.0943 0.65625 11.8125 0.65625ZM1.23133 6.5H6.5V1.71875H11.8125V5.62145C11.8127 5.91441 11.7981 6.20719 11.7687 6.49867H6.5V12.8737C5.65398 12.5914 1.69152 11.0329 1.23133 6.5Z",
    fill: "#2C9449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobIcon02);
export default __webpack_public_path__ + "static/media/job-icon-02.acf17200a1ad4f90821a8854ffa84fcb.svg";
export { ForwardRef as ReactComponent };